import React from "react";

export default () => (<svg width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="M13.963 1.963l-8.12 8.12L2.018 6.22" stroke="#000" strokeWidth="2" strokeLinecap="square"/></svg>)